import iRazAdminTestnet from './testnet/iRazAdminControls.sol/iRazAdminControls.json';
import iRazAdminMainnet from './mainnet/iRazAdminControls.sol/iRazAdminControls.json';

let iRazAdmin = iRazAdminTestnet;
if(process.env.REACT_APP_NODE_ENV === "production"){
    iRazAdmin = iRazAdminMainnet;
}

export default iRazAdmin;